module.exports = __webpack_public_path__ + "static/media/who-are-we.5f0ec456.svg";